import React from 'react'

import video from './assets/wgs.mp4'
import { Video, VideoWrapper } from './styles'

const WgsEffect = () => {
  return (
    <VideoWrapper>
      <Video autoPlay={true} playsInline={true} muted={true} loop={true}>
        <source src={video} type="video/mp4" />
      </Video>
    </VideoWrapper>
  )
}

export default WgsEffect
